import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Formik, Field, Form } from 'formik';
import styled from 'styled-components';
import { navigate } from 'gatsby';
import vars from '../lib/styled';
import lang from '../../static/lang.json';
import Button from './Button';

const SearchWrapper = styled.label`
    background-color: rgba(255, 255, 255, 0.05);
    border: 1px solid;
    border-color: transparent !important;
    color: #fff;
    display: flex;
    margin: 0 2rem;
    padding: 0.55rem;
    transition-duration: 500ms;
    transition-property: border-color, background-color;

    &:focus-within,
    &:hover {
        border-color: ${vars.contrast} !important;
    }

    @media (max-width: ${vars.breakpoint.tablet}) {
        margin-bottom: 2rem !important;
    }
`;

const Submit = styled.button`
    background-color: ${vars.primary};
`;

const Search = styled(Field)`
    background-color: ${(props) =>
        props.invert ? `${vars.contrast} !important;` : 'transparent'};

    color: #fff;
    height: auto !important;
    padding-left: 1.5vw;
    transition-duration: 250ms;
    transition-property: background-color, border-color, border-width, width;
    transition-timing-function: ease-in-out;
    width: 100%;

    &::placeholder {
        color: #fff;
        opacity: 0.87;
        text-overflow: ellipsis;
    }

    &[placeholder] {
        text-overflow: ellipsis;
    }
    &::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        text-overflow: ellipsis;
    }
    &::-moz-placeholder {
        /* Firefox 19+ */
        text-overflow: ellipsis;
    }
    &:-ms-input-placeholder {
        /* IE 10+ */
        text-overflow: ellipsis;
    }
    &:-moz-placeholder {
        /* Firefox 18- */
        text-overflow: ellipsis;
    }
`;

const SearchInput = React.forwardRef(({ locale, invert, ...rest }, ref) => {
    const btnRef = useRef();
    const name = invert ? 'searchOffcanvas' : 'searchNav';

    const onSubmit = ({ searchNav, searchOffcanvas }) => {
        const el = document.getElementById('gatsby-focus-wrapper');
        if (el) el.focus();

        navigate(
            `/${locale}/${lang.search[locale].toLowerCase()}?term=${
                searchNav || searchOffcanvas
            }`,
        );
    };

    return (
        <Formik
            initialValues={{ [name]: '' }}
            onSubmit={onSubmit}
            render={() => (
                <Form style={{ margin: 'auto' }} role="search">
                    <SearchWrapper>
                        <Search
                            {...rest}
                            invert={invert}
                            type="search"
                            innerRef={ref}
                            name={name}
                            aria-label={lang.searchTerm[locale]}
                            placeholder={`${lang.searchTerm[locale]}`}
                            style={{ outline: 1 }}
                        />
                        <Button type="submit" primary style={{ border: 0 }}>
                            {lang.search[locale]}
                        </Button>
                    </SearchWrapper>
                </Form>
            )}
        />
    );
});

SearchInput.propTypes = {
    locale: PropTypes.string.isRequired,
    invert: PropTypes.bool,
};

SearchInput.defaultProps = {
    invert: false,
};

export default SearchInput;
